import { createAction, createAsyncThunk, createSlice, PayloadAction, SerializedError } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { OrganizationPatientsApi, PatientAvailability } from "../../api/client-axios/api";
import { Configuration } from "../../api/client-axios/configuration";
import { ApiError } from "../../model/apiError";
import { PhoneValidation } from "../../model/phoneValidationType";
import { Problem } from "../../model/problem";
import {apiConfiguration} from "../server";

export interface AddPatientState {
    phoneNumber: string,
    phoneValidation: PhoneValidation,
    patientAvailability?: PatientAvailability,
    status: "idle" | "loading" | "error" | "success" | "auth-error";
    error?: string | Problem;
    code?: number;
}


const initialAddPatientState: AddPatientState = {
    phoneNumber: "",
    phoneValidation: "",
    status: "idle",
    error: ""
}

export const setPatientPhoneNumber = createAction('addPatient/setPhoneNumber', (phoneNumber: string) => { return { payload: phoneNumber }; });
export const setPatientPhoneValidation = createAction('addPatient/setPhoneValidation', (phoneValidation: PhoneValidation) => { return { payload: phoneValidation }; });
export const clearAddPatientError = createAction('addPatient/clearError');
export const initAddPatientState = createAction('addPatient/initState');

export const checkPatientAvailability = createAsyncThunk<PatientAvailability, string, { rejectValue: ApiError }>('addPatient/checkPatientAvailability', async (phoneNumber, thunkApi) => {
    try {
        const api = new OrganizationPatientsApi( apiConfiguration());
        const response = await api.apiV1OrganizationsMyAdministrationMyOrgPatientsAvailableRawPhoneNumberGet(phoneNumber);
        return response.data;
    } catch (error: AxiosError | any) {
        return thunkApi.rejectWithValue({ message: error?.response.data, statusCode: error?.response.status });
    }
}); 


const addPatientSlice = createSlice({
    name: 'addPatient',
    initialState: initialAddPatientState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(checkPatientAvailability.pending, (state, _) => {
                state.status = "loading";
            })
            .addCase(checkPatientAvailability.fulfilled, (state, action) => {
                state.patientAvailability = action.payload;
                state.status = "success";
            })
            .addCase(checkPatientAvailability.rejected, (state, action) => {
                processError(action, state);
            })
            .addCase(setPatientPhoneNumber, (state, action) => {
                state.status = "idle";
                state.phoneNumber = action.payload;
            })
            .addCase(setPatientPhoneValidation, (state, action) => {
                state.status = "idle";
                state.phoneValidation = action.payload;
            })
            .addCase(clearAddPatientError, (state, _) => {
                state.status = "idle";
            })
            .addCase(initAddPatientState, (state, _) => {
                state.phoneNumber ="";
                state.phoneValidation = "";
                state.status = "idle";
                state.error = "";
            });

           

    }
});

export default addPatientSlice.reducer;


function processError(
    action:
        PayloadAction<ApiError | undefined,
            string,
            { arg: string | string; requestId: string; requestStatus: "rejected"; aborted: boolean; condition: boolean; } &
            ({ rejectedWithValue: true; } | ({ rejectedWithValue: false; } & {})),
            SerializedError>,
    state: AddPatientState) {
    if (action.payload) {

        //state.code = action.payload.statusCode;
        //const apiError = action.payload as ApiError;
        if (action.payload !== undefined) {
            state.error = action.payload.message;
            state.code = action.payload.statusCode;
            if (state.code == 401) {
                state.status = "auth-error";
            } else {
                state.status = "error";
            }
        }
    } else {
        state.status = "error";
        state.error = action.error.message;
    }
}